import React, { useEffect, useState } from "react";
import { IconArrowDown } from "./Icons";

/**
 * Thin progress bar at the top of the viewport plus a back-to-top button.
 * Both are driven by a single passive scroll listener and only re-render
 * when a threshold is crossed, so they cost nothing while scrolling.
 */
const ScrollProgress = () => {
  const [progress, setProgress] = useState(0);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    let frame = 0;
    let lastShow = false;

    const update = () => {
      frame = 0;
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      const p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
      setProgress(p);

      const nextShow = window.scrollY > window.innerHeight * 1.5;
      if (nextShow !== lastShow) {
        lastShow = nextShow;
        setShowTop(nextShow);
      }
    };

    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <>
      <div
        className="scroll-progress"
        style={{ transform: `scaleX(${progress})` }}
        aria-hidden="true"
      />
      <button
        type="button"
        className={`to-top ${showTop ? "to-top--visible" : ""}`}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Back to top"
        tabIndex={showTop ? 0 : -1}
      >
        <IconArrowDown style={{ transform: "rotate(180deg)" }} />
      </button>
    </>
  );
};

export default ScrollProgress;
